module.exports = __webpack_public_path__ + "img/email_section_img.fb076128.jpg";